import React from "react";
import {observer} from "mobx-react-lite";
import { FormattedMessage } from "react-intl";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  Col,
  Form,
  FormGroup, Row,
} from "reactstrap";


const DefaultSettingDeleteView = observer(({store}) => {
  return (
    <>
      <Card>
        <CardBody>
          <Form>
            <FormGroup row>
              <Col sm={{size: 10, offset: 2}}>
                <Row>
                  <p className="float-left default-setting-delete-text">
                    <FormattedMessage id="deleteAction.confirmMessage.defaultSetting.defaultMessage"/>
                  </p>
                </Row>
                <Button id="delete-btn" color="danger" className="float-right" onClick={async () => {
                  await store.deleteDefaultSetting()
                }}><FormattedMessage id="deleteAction.submit.defaultMessage"/></Button>

              </Col>
            </FormGroup>
          </Form>
        </CardBody>
        <CardFooter> <FormattedMessage id="deleteAction.alertInfo.defaultSetting.defaultMessage"/></CardFooter>
        {store.formHasErrors && <div className="alert alert default-setting-error-alert" role="alert">
          <div>{store.errorMessage}</div>
        </div>}
      </Card>
    </>

  )
})
export default DefaultSettingDeleteView;
